import { render, staticRenderFns } from "./ParcelStat.vue?vue&type=template&id=83f0c334&"
import script from "./ParcelStat.vue?vue&type=script&lang=js&"
export * from "./ParcelStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports